import { useRef, useState } from 'react';

import { Box, Button, Divider, Hidden, Popover, Typography } from '@mui/material';

import { styled } from '@mui/material/styles';
import ExpandMoreTwoToneIcon from '@mui/icons-material/ExpandMoreTwoTone';
import LockOpenTwoToneIcon from '@mui/icons-material/LockOpenTwoTone';
import { PureLightTheme } from 'src/theme/schemes/PureLightTheme';

const UserBoxButton = styled(Button)(
  ({ theme }) => `
        padding-left: ${theme.spacing(1)};
        padding-right: ${theme.spacing(1)};
        background: ${theme.colors.alpha.black[100]};
        border: 1px solid ${theme.colors.alpha.white[30]};

`
);

const MenuUserBox = styled(Box)(
  ({ theme }) => `
        background: ${theme.colors.alpha.black[5]};
        padding: ${theme.spacing(1)};
`
);

const UserBoxText = styled(Box)(
  ({ theme }) => `
        text-align: center;      
        color: ${theme.colors.alpha.black[100]};
`
);

const UserBoxLabel = styled(Typography)(
  ({ theme }) => `
      
        color: ${theme.colors.alpha.white[100]};
        display: block;
`
);

const UserBoxDescription = styled(Typography)(
  ({ theme }) => `
        color: ${PureLightTheme.colors.alpha.black}
        background: ${theme.colors.alpha.black[100]};
`
);

function HeaderUserbox() {
  const user = {
    name: 'Catherine Pike',
    avatar: '/static/images/avatars/1.jpg',
    jobtitle: 'Project Manager'
  };

  const ref = useRef<any>(null);
  const [isOpen, setOpen] = useState<boolean>(false);

  const handleOpen = (): void => {
    setOpen(true);
  };

  const handleClose = (): void => {
    setOpen(false);
  };

  //Function to logout the user (remove the session storage and reload the page)
  const handleLogout = (): void => {
    sessionStorage.removeItem('isAuthenticated');
    sessionStorage.removeItem('userType');
    window.location.reload();
  };

  return (
    <>
      <UserBoxButton color="secondary" ref={ref} onClick={handleOpen}>
        <Hidden mdDown>
          <UserBoxText>
            <UserBoxLabel variant="body1"></UserBoxLabel>
          </UserBoxText>
        </Hidden>
        <ExpandMoreTwoToneIcon sx={{ color: `${PureLightTheme.colors.alpha.white[100]}` }} />
      </UserBoxButton>
      <Popover
        anchorEl={ref.current}
        onClose={handleClose}
        open={isOpen}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
      >
        <MenuUserBox sx={{ minWidth: 180 }} display="flex">
          {/* <UserBoxText>
            <UserBoxDescription variant="body1">{user.name}</UserBoxDescription>
          </UserBoxText> */}
        </MenuUserBox>
        <Divider sx={{ mb: 0 }} />
        <Divider />
        <Box sx={{ m: 0 }}>
          <Button color="inherit" fullWidth onClick={handleLogout}>
            <LockOpenTwoToneIcon sx={{ mr: 0 }} />
            Sign out
          </Button>
        </Box>
      </Popover>
    </>
  );
}

export default HeaderUserbox;
